<template>
  <div class="warning-wrapper">
    <span class="warning-text" v-if="diffInDays > 0">
      Sua parcela vence em {{ diffInDays }} {{ ( diffInDays == 1 ? 'dia' : 'dias' ) }}.
    </span>
    <span class="warning-text" v-else>
      Você pode pagar sua parcela hoje
    </span>
  </div>
</template>

<script>
export default {
  name: 'DueDateWarning',
  props: {
    diffInDays: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/scss/__new-styles.scss';

.warning-wrapper {
  position: absolute;
  top: 50px;
  width: 100%;
  left: 0px;
  padding: 16px 24px;

  width: 100%;
  height: 56px;

  background-color: var(--blue-50);

  @media (min-width: $lg) {
    display: inline-block;
    position: relative;
    grid-column-start: 1;
    grid-column-end: 3;

    padding: 16px 20px;
    margin-bottom: -4px;

    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    top: -24px;
  }
}

.warning-text {
  @extend .body-bold;
  color: var(--blue-600);

  font-size: 16px;
  line-height: 24px;

  @media (min-width: $lg) {
    font-size: 18px;
    line-height: 28px;
  }
}
</style>
